/**
 * @fileoverview added by tsickle
 * Generated from: rtcutils-core/index-output.ts
 * @suppress {checkTypes,const,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode}
 */
goog.module('rtcutils_core.index_output');
var module = module || { id: 'index-output.ts' };
goog.require('tslib');
const tsickle_interfaces_1 = goog.requireType("rtcutils_core.output.interfaces");
const tsickle_version_2 = goog.requireType("rtcutils_core.output.version");
const tsickle_genversion_3 = goog.requireType("rtcutils_core.output.genversion");
const tsickle_utils_4 = goog.requireType("rtcutils_core.output.utils");
const tsickle_settings_5 = goog.requireType("rtcutils_core.output.settings");
const tsickle_eventemitter_6 = goog.requireType("rtcutils_core.output.eventemitter");
const tsickle_logger_7 = goog.requireType("rtcutils_core.output.logger");
const tsickle_platform_8 = goog.requireType("rtcutils_core.output.platform");
const tsickle_enumnames_9 = goog.requireType("rtcutils_core.output.enumnames");
const tsickle_legacylogemitter_10 = goog.requireType("rtcutils_core.output.legacylogemitter");
const tsickle_workerutils_11 = goog.requireType("rtcutils_core.output.workerutils");
const tsickle_translateplatform_12 = goog.requireType("rtcutils_core.output.translateplatform");
const tsickle_extensions_13 = goog.requireType("rtcutils_core.output.extensions");
const tsickle_tracingmanager_14 = goog.requireType("rtcutils_core.output.tracingmanager");
const tsickle_observablearray_15 = goog.requireType("rtcutils_core.output.observablearray");
const tsickle_cancellablewait_16 = goog.requireType("rtcutils_core.output.cancellablewait");
const tsickle_types_17 = goog.requireType("rtcutils_core.output.types");
const tsickle_internaltypes_18 = goog.requireType("rtcutils_core.output.internaltypes");
const tsickle_telemetry_19 = goog.requireType("rtcutils_core.output.telemetry");
((/** @type {?} */ (window)))["RtcUtils"] = ((/** @type {?} */ (window)))["RtcUtils"] || {};
/* Typings to be exposed to library user */
const interfaces_1 = goog.require('rtcutils_core.output.interfaces');
/** @typedef {!tsickle_interfaces_1.LogEvent} */
exports.LogEvent; // re-export typedef
/** @typedef {!tsickle_interfaces_1.authTokenCallbackType} */
exports.authTokenCallbackType; // re-export typedef
/** @typedef {!tsickle_interfaces_1.AuthInfo} */
exports.AuthInfo; // re-export typedef
/** @typedef {!tsickle_interfaces_1.ErrorDetails} */
exports.ErrorDetails; // re-export typedef
const version_1 = goog.require('rtcutils_core.output.version');
exports.CHANGELIST = version_1.CHANGELIST;
const genversion_1 = goog.require('rtcutils_core.output.genversion');
exports.PackageVersion = genversion_1.version;
const utils_1 = goog.require('rtcutils_core.output.utils');
exports.IsXbox = utils_1.IsXbox;
exports.IsEdge = utils_1.IsEdge;
exports.IsXboxEdge = utils_1.IsXboxEdge;
exports.IsiOS = utils_1.IsiOS;
exports.IsiPadOS = utils_1.IsiPadOS;
exports.IsiDevice = utils_1.IsiDevice;
exports.IsVisionPro = utils_1.IsVisionPro;
exports.IsValidIPv4 = utils_1.IsValidIPv4;
exports.GetRandNumericString = utils_1.GetRandNumericString;
exports.convertToUnsignedInt = utils_1.convertToUnsignedInt;
exports.GetHexString = utils_1.GetHexString;
exports.isUnifiedErrorCode = utils_1.isUnifiedErrorCode;
exports.IsChromium = utils_1.IsChromium;
exports.IsSafari = utils_1.IsSafari;
exports.IsiPhone = utils_1.IsiPhone;
exports.IsiPad = utils_1.IsiPad;
exports.IsWebOS = utils_1.IsWebOS;
exports.IsChromeOS = utils_1.IsChromeOS;
exports.IsWindowsOS = utils_1.IsWindowsOS;
exports.IsMacOS = utils_1.IsMacOS;
exports.IsTizenOS = utils_1.IsTizenOS;
exports.IsLinuxOS = utils_1.IsLinuxOS;
exports.IsAndroidOS = utils_1.IsAndroidOS;
exports.IsSteamDeck = utils_1.IsSteamDeck;
exports.IsFirefox = utils_1.IsFirefox;
exports.performHttpRequest = utils_1.performHttpRequest;
exports.IsTouchDevice = utils_1.IsTouchDevice;
exports.IsTouchCapable = utils_1.IsTouchCapable;
exports.IsTV = utils_1.IsTV;
exports.isMobile = utils_1.isMobile;
exports.getNewGuid = utils_1.getNewGuid;
exports.IsChromeBrowser = utils_1.IsChromeBrowser;
exports.IsChromeVersionAtLeast = utils_1.IsChromeVersionAtLeast;
exports.IsSafariVersionAtLeast = utils_1.IsSafariVersionAtLeast;
exports.IsiOSVersion = utils_1.IsiOSVersion;
exports.IsiOSVersionAtLeast = utils_1.IsiOSVersionAtLeast;
exports.customFetch = utils_1.customFetch;
exports.getRErrorDetails = utils_1.getRErrorDetails;
exports.convertNetworkTypeToTelemetryType = utils_1.convertNetworkTypeToTelemetryType;
exports.DefaultHttpRequestOptions = utils_1.DefaultHttpRequestOptions;
/** @typedef {!tsickle_utils_4.HttpRequestHeaders} */
exports.HttpRequestHeaders; // re-export typedef
/** @typedef {!tsickle_utils_4.RequestHttpOptions} */
exports.RequestHttpOptions; // re-export typedef
/** @typedef {!tsickle_utils_4.Response} */
exports.Response; // re-export typedef
/** @typedef {!tsickle_utils_4.FetchResponse} */
exports.FetchResponse; // re-export typedef
const settings_1 = goog.require('rtcutils_core.output.settings');
exports.toBool = settings_1.toBool;
exports.ConfigureRtcUtilsSettings = settings_1.ConfigureRtcUtilsSettings;
exports.RtcUtilsSettings = settings_1.RtcUtilsSettings;
/** @typedef {!tsickle_settings_5.RtcUtilConfigData} */
exports.RtcUtilConfigData; // re-export typedef
const eventemitter_1 = goog.require('rtcutils_core.output.eventemitter');
exports.EventEmitter = eventemitter_1.EventEmitter;
/** @typedef {!tsickle_eventemitter_6.IEventEmitter} */
exports.IEventEmitter; // re-export typedef
const logger_1 = goog.require('rtcutils_core.output.logger');
exports.registerLogCallback = logger_1.registerLogCallback;
exports.LogImpl = logger_1.LogImpl;
exports.Log = logger_1.Log;
/** @typedef {!tsickle_logger_7.LogData} */
exports.LogData; // re-export typedef
/** @typedef {!tsickle_logger_7.LogCallback} */
exports.LogCallback; // re-export typedef
const platform_1 = goog.require('rtcutils_core.output.platform');
exports.GetPlatformDetails = platform_1.GetPlatformDetails;
exports.AddPlatformTelemetry = platform_1.AddPlatformTelemetry;
exports.getPlatformDetails = platform_1.getPlatformDetails;
/** @typedef {!tsickle_platform_8.PlatformDetails} */
exports.PlatformDetails; // re-export typedef
const enumnames_1 = goog.require('rtcutils_core.output.enumnames');
const legacylogemitter_1 = goog.require('rtcutils_core.output.legacylogemitter');
exports.LegacyLogEmitter = legacylogemitter_1.LegacyLogEmitter;
const workerutils_1 = goog.require('rtcutils_core.output.workerutils');
exports.makeWorkerFromInterface = workerutils_1.makeWorkerFromInterface;
exports.makeSharedWorkerFromInterface = workerutils_1.makeSharedWorkerFromInterface;
exports.stopWorker = workerutils_1.stopWorker;
/** @typedef {!tsickle_workerutils_11.CmdMsg} */
exports.CmdMsg; // re-export typedef
/** @typedef {!tsickle_workerutils_11.DoWork} */
exports.DoWork; // re-export typedef
/** @typedef {!tsickle_workerutils_11.WorkerResultCallback} */
exports.WorkerResultCallback; // re-export typedef
/** @typedef {!tsickle_workerutils_11.SharedWorker} */
exports.SharedWorker; // re-export typedef
const translateplatform_1 = goog.require('rtcutils_core.output.translateplatform');
exports.translatePlatformDetailsForPayload = translateplatform_1.translatePlatformDetailsForPayload;
exports.translatePlatformDetailsForClientHeader = translateplatform_1.translatePlatformDetailsForClientHeader;
/** @typedef {!tsickle_translateplatform_12.PayloadPlatformDetails} */
exports.PayloadPlatformDetails; // re-export typedef
/** @typedef {!tsickle_translateplatform_12.ClientHeaderPlatformDetails} */
exports.ClientHeaderPlatformDetails; // re-export typedef
const extensions_1 = goog.require('rtcutils_core.output.extensions');
const tracingmanager_1 = goog.require('rtcutils_core.output.tracingmanager');
exports.TracingManager = tracingmanager_1.TracingManager;
const observablearray_1 = goog.require('rtcutils_core.output.observablearray');
exports.ObservableArray = observablearray_1.ObservableArray;
const cancellablewait_1 = goog.require('rtcutils_core.output.cancellablewait');
exports.CancellableWait = cancellablewait_1.CancellableWait;
const types_1 = goog.require('rtcutils_core.output.types');
const internaltypes_1 = goog.require('rtcutils_core.output.internaltypes');
exports.TelemetryEventBase = internaltypes_1.TelemetryEventBase;
exports.GS_FeatureDef = internaltypes_1.GS_FeatureDef;
exports.GS_SystemAPICallResultDef = internaltypes_1.GS_SystemAPICallResultDef;
exports.GS_DebugInfoDef = internaltypes_1.GS_DebugInfoDef;
exports.GS_ExceptionInfoDef = internaltypes_1.GS_ExceptionInfoDef;
exports.GS_ClientMetricEventDef = internaltypes_1.GS_ClientMetricEventDef;
exports.GS_ConnectivityCheckDef = internaltypes_1.GS_ConnectivityCheckDef;
exports.GS_Sleep_EventDef = internaltypes_1.GS_Sleep_EventDef;
exports.GS_WsCallResultDef = internaltypes_1.GS_WsCallResultDef;
exports.GS_HttpCallResultDef = internaltypes_1.GS_HttpCallResultDef;
exports.GS_PropertyChange_EventDef = internaltypes_1.GS_PropertyChange_EventDef;
exports.GS_CodecError_EventDef = internaltypes_1.GS_CodecError_EventDef;
/** @typedef {!tsickle_internaltypes_18.RemoteOverrideInfo} */
exports.RemoteOverrideInfo; // re-export typedef
/** @typedef {!tsickle_internaltypes_18.RemoteConfigData} */
exports.RemoteConfigData; // re-export typedef
/** @typedef {!tsickle_internaltypes_18.GxtConfigParams} */
exports.GxtConfigParams; // re-export typedef
/** @typedef {!tsickle_internaltypes_18.GxtRemoteConfigData} */
exports.GxtRemoteConfigData; // re-export typedef
/** @typedef {!tsickle_internaltypes_18.GS_Feature} */
exports.GS_Feature; // re-export typedef
/** @typedef {!tsickle_internaltypes_18.GS_SystemAPICallResult} */
exports.GS_SystemAPICallResult; // re-export typedef
/** @typedef {!tsickle_internaltypes_18.GS_DebugInfo} */
exports.GS_DebugInfo; // re-export typedef
/** @typedef {!tsickle_internaltypes_18.GS_ExceptionInfo} */
exports.GS_ExceptionInfo; // re-export typedef
/** @typedef {!tsickle_internaltypes_18.GS_ClientMetricEvent} */
exports.GS_ClientMetricEvent; // re-export typedef
/** @typedef {!tsickle_internaltypes_18.GS_ConnectivityCheck} */
exports.GS_ConnectivityCheck; // re-export typedef
/** @typedef {!tsickle_internaltypes_18.GS_Sleep_Event} */
exports.GS_Sleep_Event; // re-export typedef
/** @typedef {!tsickle_internaltypes_18.GS_WsCallResult} */
exports.GS_WsCallResult; // re-export typedef
/** @typedef {!tsickle_internaltypes_18.GS_HttpCallResult} */
exports.GS_HttpCallResult; // re-export typedef
/** @typedef {!tsickle_internaltypes_18.GS_PropertyChange_Event} */
exports.GS_PropertyChange_Event; // re-export typedef
/** @typedef {!tsickle_internaltypes_18.GS_CodecError_Event} */
exports.GS_CodecError_Event; // re-export typedef
const telemetry_1 = goog.require('rtcutils_core.output.telemetry');
exports.TelemetryImpl = telemetry_1.TelemetryImpl;
/** @typedef {!tsickle_telemetry_19.ClientTelemetryConfig} */
exports.ClientTelemetryConfig; // re-export typedef
/** @typedef {!tsickle_telemetry_19.TelemetryEventPayload} */
exports.TelemetryEventPayload; // re-export typedef
/** @typedef {!tsickle_telemetry_19.TelemetryEventIds} */
exports.TelemetryEventIds; // re-export typedef
/** @typedef {!tsickle_telemetry_19.FormattedEventDetail} */
exports.FormattedEventDetail; // re-export typedef
/** @typedef {!tsickle_telemetry_19.TelemetryCommonData} */
exports.TelemetryCommonData; // re-export typedef
/** @typedef {!tsickle_telemetry_19.TelemetryCallback} */
exports.TelemetryCallback; // re-export typedef
/** @typedef {!tsickle_telemetry_19.TelemetryConfiguration} */
exports.TelemetryConfiguration; // re-export typedef
/** @typedef {!tsickle_telemetry_19.Telemetry} */
exports.Telemetry; // re-export typedef
